import { Laptop, Moon, Sun } from 'lucide-react';
import { Button } from '@agenda-facil/ui';
import { applyTheme, useThemeStore, type ThemePreference } from '../stores/theme-store';

const order: ThemePreference[] = ['light', 'dark', 'system'];

export function ThemeToggle() {
  const { preference, setPreference } = useThemeStore();
  const Icon = preference === 'light' ? Sun : preference === 'dark' ? Moon : Laptop;
  const label = preference === 'light' ? 'Tema claro' : preference === 'dark' ? 'Tema escuro' : 'Tema automático';

  return (
    <Button
      type="button"
      variant="ghost"
      size="icon"
      aria-label={`${label}. Alterar tema`}
      title={label}
      onClick={() => {
        const next = order[(order.indexOf(preference) + 1) % order.length] ?? 'system';
        setPreference(next);
        applyTheme(next);
      }}
    >
      <Icon size={19} />
    </Button>
  );
}
